import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'

export default function TableProjectSummary({ schema, header }) {
  const [isLoadingTable, setIsLoadingTable] = useState(true)
  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    if (!schema.tableData) {
      setIsLoadingTable(true)
    } else {
      setIsLoadingTable(false)
    }
  }, [schema.tableData])

  return (
    <>
      <Panel header={header} bordered bodyFill collapsible style={{ marginTop: 5 }} defaultExpanded>
        <Table height={480} data={schema.tableData} loading={isLoadingTable}>
          <Column flexGrow={1}>
            <HeaderCell>
              <span>{schema.projectStatusTitle}</span>
            </HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column align="center" width={220}>
            <HeaderCell>
              <span>{schema.quantityTitle}</span>
            </HeaderCell>
            <Cell dataKey="projectSummary" />
          </Column>

          <Column align="center" width={220}>
            <HeaderCell>
              <span>{schema.percentTitle}</span>
            </HeaderCell>
            <Cell dataKey="summaryPercent" />
          </Column>

          {/* <Column align="center" >
            <HeaderCell></HeaderCell>
            <Cell dataKey="" />
          </Column> */}
        </Table>
      </Panel>
    </>
  )
}
